import styles from "../../assets/styles/loader.module.css";
const BtnLoader = () => {
    return (
            <div className={styles.buttonLoaderAll}></div>
    )
}

export default BtnLoader